import { useTheme } from '@mui/material';

export const IntroIcon4 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 27C11 31.4183 14.5817 35 19 35H27C31.4183 35 35 31.4183 35 27V19C35 14.5817 31.4183 11 27 11H17C13.6863 11 11 13.6863 11 17V27Z"
                fill={primaryBackground}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.5 24C9.5 27.5899 12.4101 30.5 16 30.5H24C27.5899 30.5 30.5 27.5899 30.5 24V16C30.5 12.4101 27.5899 9.5 24 9.5H16C12.4101 9.5 9.5 12.4101 9.5 16V24ZM8 24C8 28.4183 11.5817 32 16 32H24C28.4183 32 32 28.4183 32 24V16C32 11.5817 28.4183 8 24 8H16C11.5817 8 8 11.5817 8 16V24ZM20.75 15C20.75 14.5858 20.4142 14.25 20 14.25C19.5858 14.25 19.25 14.5858 19.25 15V22.5C19.25 22.9142 19.5858 23.25 20 23.25C20.4142 23.25 20.75 22.9142 20.75 22.5V15ZM20.75 25.5C20.75 25.0858 20.4142 24.75 20 24.75C19.5858 24.75 19.25 25.0858 19.25 25.5V26C19.25 26.4142 19.5858 26.75 20 26.75C20.4142 26.75 20.75 26.4142 20.75 26V25.5Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
